<template>
  <SogFlexRow>
    <SogCard :style="_style">
      <SogCardTitle>
        Lager
      </SogCardTitle>
      <SogCardActions
        :is-toolbar="true"
      >
        <SogCardActionButton
          v-for="blank in _storeExportBlank"
          :key="blank"
          @click="onAddExportBlank(blank)"
        >
          <div
            v-show="blank.isInShoppingCart"
            class="deleted"
          >
            {{ blank.insuranceNumber }}<br>{{ blank.blankNumber }}
          </div>
          <div v-show="!blank.isInShoppingCart">
            {{ blank.insuranceNumber }}<br>{{ blank.blankNumber }}
          </div>
        </SogCardActionButton>
      </SogCardActions>
    </SogCard>
    <SogCard :style="_style">
      <SogCardTitle>Ausgewählt</SogCardTitle>
      <SogCardActions
        :is-toolbar="true"

        style="justify-content: flex-start; align-items: start"
      >
        <SogCardActionButton
          v-for="blank in _shoppingCartStore.getCurrentItem().shoppingCartItem.insuranceExportBlanks"
          :key="blank"
          @click="onRemoveExportBlank(blank)"
        >
          {{ blank.insuranceNumber }}<br>{{ blank.blankNumber }}
        </SogCardActionButton>
      </SogCardActions>
    </SogCard>
  </SogFlexRow>

  <!--
    <table>
      <tr>
        <th style="text-align: center">
          Lager
        </th>
        <th style="text-align: center">
          Ausgewählt
        </th>
      </tr>
      <tr>
        <td style=" vertical-align:top;width: 50%">
          <SogCardActions
            v-for="blank in _storeExportBlank"
            :key="blank"
            :is-toolbar="true"
          >
            <SogCardActionButton @click="onAddExportBlank(blank)">
              {{ blank.insuranceNumber }}<br>{{ blank.blankNumber }}
            </SogCardActionButton>
          </SogCardActions>
        </td>
        <td style=" vertical-align:top">
          <SogCardActions
            v-for="blank in _shoppingCartStore.getCurrentItem().shoppingCartItem.insuranceExportBlanks"
            :key="blank"
            :is-toolbar="true"

            style="justify-content: flex-start; align-items: start"
          >
            <SogCardActionButton @click="onRemoveExportBlank(blank)">
              {{ blank.insuranceNumber }}<br>{{ blank.blankNumber }}
            </SogCardActionButton>
          </SogCardActions>
        </td>
      </tr>
    </table>
  -->
</template>

<script setup lang="ts">
import {computed, ref, watch} from "vue";
import InsuranceExportBlank, {sortInsuranceExportBlank} from "@/shared/model/InsuranceExportBlank";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogCard from "@/shared/ui/SogCard.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {useDisplay} from "vuetify";

interface Props {
  exportBlanks: InsuranceExportBlank[],
}

const props = defineProps<Props>()

const {mobile} = useDisplay()

const _shoppingCartStore = useShoppingCartStore();
const _storeExportBlank = ref<InsuranceExportBlank[]>([])

function onAddExportBlank(blank: InsuranceExportBlank) {
  if(blank.isInShoppingCart===true) return;
  _shoppingCartStore.addInsuranceExportBlank(blank)
  //_storeExportBlank.value = _storeExportBlank.value.filter(t => t.id != blank.id)
}

function onRemoveExportBlank(blank: InsuranceExportBlank) {
  _shoppingCartStore.removeInsuranceExportBlank(blank)
  _storeExportBlank.value = sortInsuranceExportBlank([..._storeExportBlank.value, blank])
}

watch((props), () => {
  _storeExportBlank.value = [...props.exportBlanks]
}, {immediate: true})

const _style = computed(()=>{
  if(mobile.value){
    return "";
  }
  return "width: 49%";
})

</script>

<style>
.deleted {
  text-decoration: line-through;
}

</style>
